import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
    // root: {
    //     display: 'flex',
    // },
    GridContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 10,
        backgroundColor: '#fff',
        borderRadius: '5px',
    },
    GridContainerResp: {
        display: 'grid',
        gridTemplateColumns: 'repeat(1, 1fr)',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 10,
        backgroundColor: '#fff',
        borderRadius: '5px',
    },
    MainHubContainer: {
        margin: '10px',
        overflowY: 'auto',
    },
    videoBox: {
        display: "flex",
        flexDirection: 'column',
        alignSelf: 'flex-end',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        width: '100%',
        maxHeight: '105%',
        margin: 0,
        overflowY: 'hidden',
        boxShadow: '0px 1px 5px 0px #ccc',
        borderRadius: '10px',
        overflow: 'hidden',
        transition: 'all 200ms',
        '&:hover': {
            boxShadow: '1px 1px 5px 2px #ccc',
        }
    },
    // azuremediaplayerDiv: {
    //     height: '100%',
    //     paddingBottom: '1%',
    // },
    // azuremediaplayer: {
    //     background: '#ccc',
    //     width: '100%',
    //     height: '0',
    //     display: 'block',
    //     padding: '0',
    //     position: 'relative',
    //     overflow: 'hidden',
    // },
    PaginationContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '24px'
    },
    DescriptionBox: {
        display: 'flex',
        flexDirection: 'column',
        justifySelf: 'flex-end',
        padding: '2px',
        fontSize: '.8em',
        fontWeight: 500,
        height: '120px',
        margin: '2px',
        marginBottom: '10px',
        lineClamp: 2,
        overflow: 'hidden',
    },
    VideoDescription: {
        color: '#030303',
        fontWeight: 650,
        marginRight: '2px'
    },
    VideoDurationBox: {
        display: 'flex',
        alignItems: 'center',
        color: '#000',
        fontSize: '.7rem',
        marginRight: '5px',
        padding: '4px',
        borderRadius: '5px',
        opacity: .9,
    },
    VideoDescriptionFooter: {
        color: '#222',
        fontSize: '.7rem',
        marginRight: '5px',

    },
    CounterBox: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        borderRadius: '15px',
        background: '#fff',
        border: '1.5px solid #2a4a8462',
    },
    VideoDescriptionCounter: {
        fontSize: '.7rem',
        fontWeight: 'bold',
        color: '#2A4A84',
        margin: '4px',
    },
    azuremediaplayerDiv: {
        position: 'relative',
        "&:before": {
            content: "' '",
            position: 'absolute',
            backgroundImage: 'url(https://appsdev.cotemar.com.mx/logos/general/LogoCotemarCentradoBlanco.png)',
            backgroundSize: 'cover',
            width: '44px',
            height: '65px',
            right: '20px',
            bottom: '20px',
            opacity: '.6'
        }


    }

}));

